import { lazy } from 'react';
import deliveryPath from 'src/constants/urlPath/erp/deliveryPath';
import type { RouteType } from 'src/hooks/useRouteElements';
import NewLayout from '../../layouts/NewFeatures/MainLayout';
import { PermissionEn } from '@martech-solution/utils/constants';

const DeliveryOrder = lazy(() => import('src/pages/ERP/ContractExecution/Delivery/DeliveryOrder'));
// const DeliveryOrder = lazy(() => import('src/pages/ERP/ContractExecution/Production/DeliveryOrder'));
const AddDeliveryOrder = lazy(() => import('src/pages/ERP/ContractExecution/Delivery/DeliveryOrder/AddDeliveryOrder'));

const Incoterm = lazy(() => import('src/pages/ERP/Accounting/Incoterm'));
const IncotermForm = lazy(() => import('src/pages/ERP/Accounting/Incoterm/IncotermForm'));
const TradePaymentMethod = lazy(() => import('src/pages/ERP/Accounting/TradePaymentMethod'));
const TradePaymentMethodForm = lazy(() => import('src/pages/ERP/Accounting/TradePaymentMethod/TradePaymentMethodForm'));
const PaymentDocument = lazy(() => import('src/pages/ERP/Accounting/PaymentDocument'));
const PaymentDocumentForm = lazy(() => import('src/pages/ERP/Accounting/PaymentDocument/PaymentDocumentForm'));
const MainShippingMethod = lazy(() => import('src/pages/ERP/Accounting/MainShippingMethod'));
const MainShippingMethodForm = lazy(() => import('src/pages/ERP/Accounting/MainShippingMethod/MainShippingMethodForm'));
const ShippingStage = lazy(() => import('src/pages/ERP/Accounting/ShippingStage'));
const ShippingStageForm = lazy(() => import('src/pages/ERP/Accounting/ShippingStage/ShippingStageForm'));
const InternationalTradeAgreement = lazy(() => import('src/pages/ERP/Accounting/InternationalTradeAgreement'));
const InternationalTradeAgreementForm = lazy(
  () => import('src/pages/ERP/Accounting/InternationalTradeAgreement/InternationalTradeAgreementForm')
);
const PaymentDocumentDetailRequirement = lazy(
  () => import('src/pages/ERP/Accounting/PaymentDocumentDetailRequirement')
);
const PaymentDocumentDetailRequirementForm = lazy(
  () => import('src/pages/ERP/Accounting/PaymentDocumentDetailRequirement/PaymentDocumentDetailRequirementForm')
);

// const ProductionRequest = lazy(() => import('src/pages/ERP/ContractExecution/Production/ProductionRequest'));
// const AddProductionRequest = lazy(
//   () => import('src/pages/ERP/ContractExecution/Production/ProductionRequest/AddProductionRequest')
// );

const deliveryRoutes: RouteType[] = [
  // Delivery order - DS yêu cầu giao hàng
  {
    path: deliveryPath.deliveryOrder,
    Layout: NewLayout,
    Component: DeliveryOrder
  },
  {
    path: deliveryPath.deliveryOrderAdd,
    Layout: NewLayout,
    Component: AddDeliveryOrder
  },
  {
    path: `${deliveryPath.deliveryOrderEdit}/:id`,
    Layout: NewLayout,
    Component: AddDeliveryOrder
  },
  {
    path: `${deliveryPath.deliveryOrderDetail}/:id`,
    Layout: NewLayout,
    Component: AddDeliveryOrder
  },

  // Incoterm
  {
    path: deliveryPath.incoterm,
    Layout: NewLayout,
    Component: Incoterm,
    permission: PermissionEn.read
  },
  {
    path: deliveryPath.incotermAdd,
    Layout: NewLayout,
    Component: IncotermForm,
    checkPath: deliveryPath.incoterm,
    permission: PermissionEn.create
  },
  {
    path: `${deliveryPath.incotermEdit}/:id`,
    Layout: NewLayout,
    Component: IncotermForm,
    checkPath: deliveryPath.incoterm,
    permission: PermissionEn.update
  },
  {
    path: `${deliveryPath.incotermDetail}/:id`,
    Layout: NewLayout,
    Component: IncotermForm,
    checkPath: deliveryPath.incoterm,
    permission: PermissionEn.viewDetail
  },

  // Payment Method
  {
    path: deliveryPath.tradePaymentMethod,
    Layout: NewLayout,
    Component: TradePaymentMethod,
    permission: PermissionEn.read
  },
  {
    path: deliveryPath.tradePaymentMethodAdd,
    Layout: NewLayout,
    Component: TradePaymentMethodForm,
    checkPath: deliveryPath.tradePaymentMethod,
    permission: PermissionEn.create
  },
  {
    path: `${deliveryPath.tradePaymentMethodEdit}/:id`,
    Layout: NewLayout,
    Component: TradePaymentMethodForm,
    checkPath: deliveryPath.tradePaymentMethod,
    permission: PermissionEn.update
  },
  {
    path: `${deliveryPath.tradePaymentMethodDetail}/:id`,
    Layout: NewLayout,
    Component: TradePaymentMethodForm,
    checkPath: deliveryPath.tradePaymentMethod,
    permission: PermissionEn.viewDetail
  },

  // Payment Document
  {
    path: deliveryPath.paymentDocument,
    Layout: NewLayout,
    Component: PaymentDocument,
    permission: PermissionEn.read
  },
  {
    path: deliveryPath.paymentDocumentAdd,
    Layout: NewLayout,
    Component: PaymentDocumentForm,
    checkPath: deliveryPath.paymentDocument,
    permission: PermissionEn.create
  },
  {
    path: `${deliveryPath.paymentDocumentEdit}/:id`,
    Layout: NewLayout,
    Component: PaymentDocumentForm,
    checkPath: deliveryPath.paymentDocument,
    permission: PermissionEn.update
  },
  {
    path: `${deliveryPath.paymentDocumentDetail}/:id`,
    Layout: NewLayout,
    Component: PaymentDocumentForm,
    checkPath: deliveryPath.paymentDocument,
    permission: PermissionEn.viewDetail
  },

  // Main shipping method
  {
    path: deliveryPath.mainShippingMethod,
    Layout: NewLayout,
    Component: MainShippingMethod,
    permission: PermissionEn.read
  },
  {
    path: deliveryPath.mainShippingMethodAdd,
    Layout: NewLayout,
    Component: MainShippingMethodForm,
    checkPath: deliveryPath.mainShippingMethod,
    permission: PermissionEn.create
  },
  {
    path: `${deliveryPath.mainShippingMethodEdit}/:id`,
    Layout: NewLayout,
    Component: MainShippingMethodForm,
    checkPath: deliveryPath.mainShippingMethod,
    permission: PermissionEn.update
  },
  {
    path: `${deliveryPath.mainShippingMethodDetail}/:id`,
    Layout: NewLayout,
    Component: MainShippingMethodForm,
    checkPath: deliveryPath.mainShippingMethod,
    permission: PermissionEn.viewDetail
  },

  // Shipping stage
  {
    path: deliveryPath.shippingStage,
    Layout: NewLayout,
    Component: ShippingStage,
    permission: PermissionEn.read
  },
  {
    path: deliveryPath.shippingStageAdd,
    Layout: NewLayout,
    Component: ShippingStageForm,
    checkPath: deliveryPath.shippingStage,
    permission: PermissionEn.create
  },
  {
    path: `${deliveryPath.shippingStageEdit}/:id`,
    Layout: NewLayout,
    Component: ShippingStageForm,
    checkPath: deliveryPath.shippingStage,
    permission: PermissionEn.update
  },
  {
    path: `${deliveryPath.shippingStageDetail}/:id`,
    Layout: NewLayout,
    Component: ShippingStageForm,
    checkPath: deliveryPath.shippingStage,
    permission: PermissionEn.viewDetail
  },

  // International Trade Agreement - ĐIỀU ƯỚC VÀ PHÁP LUẬT QUỐC TẾ
  {
    path: deliveryPath.internationalTradeAgreement,
    Layout: NewLayout,
    Component: InternationalTradeAgreement,
    permission: PermissionEn.read
  },
  {
    path: deliveryPath.internationalTradeAgreementAdd,
    Layout: NewLayout,
    Component: InternationalTradeAgreementForm,
    checkPath: deliveryPath.internationalTradeAgreement,
    permission: PermissionEn.create
  },
  {
    path: `${deliveryPath.internationalTradeAgreementEdit}/:id`,
    Layout: NewLayout,
    Component: InternationalTradeAgreementForm,
    checkPath: deliveryPath.internationalTradeAgreement,
    permission: PermissionEn.update
  },
  {
    path: `${deliveryPath.internationalTradeAgreementDetail}/:id`,
    Layout: NewLayout,
    Component: InternationalTradeAgreementForm,
    checkPath: deliveryPath.internationalTradeAgreement,
    permission: PermissionEn.viewDetail
  },

  // Payment document detail requirement
  {
    path: deliveryPath.paymentDocumentDetailRequirement,
    Layout: NewLayout,
    Component: PaymentDocumentDetailRequirement,
    permission: PermissionEn.read
  },
  {
    path: deliveryPath.paymentDocumentDetailRequirementAdd,
    Layout: NewLayout,
    Component: PaymentDocumentDetailRequirementForm,
    checkPath: deliveryPath.paymentDocumentDetailRequirement,
    permission: PermissionEn.create
  },
  {
    path: `${deliveryPath.paymentDocumentDetailRequirementEdit}/:id`,
    Layout: NewLayout,
    Component: PaymentDocumentDetailRequirementForm,
    checkPath: deliveryPath.paymentDocumentDetailRequirement,
    permission: PermissionEn.update
  },
  {
    path: `${deliveryPath.paymentDocumentDetailRequirementDetail}/:id`,
    Layout: NewLayout,
    Component: PaymentDocumentDetailRequirementForm,
    checkPath: deliveryPath.paymentDocumentDetailRequirement,
    permission: PermissionEn.viewDetail
  }
  // Delivery request - Lệnh giao hàng
  //   {
  //     path: deliveryPath.productionRequest,
  //     Layout: NewLayout,
  //     Component: ProductionRequest
  //   },
  //   {
  //     path: deliveryPath.productionRequestAdd,
  //     Layout: NewLayout,
  //     Component: AddProductionRequest
  //   },
  //   {
  //     path: `${deliveryPath.productionRequestEdit}/:code`,
  //     Layout: NewLayout,
  //     Component: AddProductionRequest
  //   },
  //   {
  //     path: `${deliveryPath.productionRequestDetailCode}/:code`,
  //     Layout: NewLayout,
  //     Component: AddProductionRequest
  //   },
];

export default deliveryRoutes;
